<template>
    <div>

        <b-modal id="add-idle" title="Oluştur" no-close-on-esc no-close-on-backdrop>
            <draft-price-idle-route-add v-model="idleRoute"></draft-price-idle-route-add>
            <template #modal-footer><v-executer :disabled="!idleRoute.Province || !idleRoute.District" :loading="idleAdding" :editing="false" :action="multipleIdleAdding ? addMultipleIdle : addIdle"></v-executer></template>
        </b-modal>

        <b-modal id="add-idle-exact" title="Oluştur" no-close-on-esc no-close-on-backdrop>
            <draft-price-idle-exact-route-add v-model="idleRoute"></draft-price-idle-exact-route-add>
            <template #modal-footer><v-executer :disabled="!idleRoute.Province || !idleRoute.District || !idleRoute.Neighbourhood || !idleRoute.LatLng" :loading="idleAdding" :editing="false" :action="multipleIdleAdding ? addMultipleIdle : addIdle"></v-executer></template>
        </b-modal>

        <b-modal modal-class="fullscreen-modal" id="show-route" title="Rota" no-close-on-esc no-close-on-backdrop hide-footer>
            <google-maps-show-route :route="route"></google-maps-show-route>
        </b-modal>

        <b-modal id="edit-route" title="Düzenle" no-close-on-esc no-close-on-backdrop>
            <draft-price-edit-route-detail v-model="route"></draft-price-edit-route-detail>
            <template #modal-footer><v-executer :disabled="route.countOfDaysWorked < route.defaultCountOfDaysWorked" text="Güncelle" :action="updateRoute"></v-executer></template>
        </b-modal>

        <div v-if="value.UncalculatedRoutes.length" class="mb-1 row justify-content-between mt-1">
            <div class="col-md-auto mb-1 mb-lg-0">
                <div class="row">
                    <div class="col-md-auto mb-1 mb-md-0" v-if="type == 2">
                        <button class="btn btn-dark w-100" v-on:click="c_selectedCalculatedRoutes == 0 ? selectAll() : unselectAll()">
                            {{c_selectedCalculatedRoutes > 0 ? `Seçilenleri Kaldır (${c_selectedCalculatedRoutes})` : 'Tümünü Seç'}}
                        </button>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-danger w-100" v-on:click="deleteAll">
                            Tüm Rotaları Sil
                        </button>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0" v-if="type == 2">
                        <button :disabled="c_selectedCalculatedRoutes == 0" class="btn btn-primary w-100" v-on:click="editMultipleIdle">
                            <feather-icon icon="GitCommitIcon" class="mr-50"></feather-icon>
                            Aylak Rota Ekle ({{c_selectedCalculatedRoutes}})
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="col-md-3">
                <b-input-group class="input-group-merge">
                    <template #prepend>
                        <b-input-group-text >
                            <feather-icon icon="SearchIcon"></feather-icon>
                        </b-input-group-text>
                    </template>
                    <b-form-input v-model="searchValue" placeholder="Ara..." ></b-form-input>
                </b-input-group>
            </div>
        </div>
    
        <template v-for="(route,index) in c_filteredCalculatedRoutes">
            <draft-price-calculated-box :route="route" 
                                        :key="index"
                                        :type="type"
                                        v-on:edit-idle="editIdle($event)"
                                        v-on:show-route="showRoute($event)"
                                        v-on:delete="deleteRoute($event,index)"
                                        v-on:remove-idle="removeIdle($event)"
                                        v-on:change-detail="edit($event)"></draft-price-calculated-box>
        </template>
        <template v-if="searchValue && c_filteredCalculatedRoutes.length ==0">
            <div class="alert alert-secondary mt-1 mb-0">
                <div class="alert-body text-center">
                    Aradığınız rota bulunamadı.
                </div>
            </div>
        </template>
        <template v-if="!searchValue && c_filteredCalculatedRoutes.length ==0">
            <div class="alert alert-dark mt-1 mb-0">
                <div class="alert-body text-center">
                    Henüz bir rota hesaplanmadı.
                </div>
            </div>
        </template>

        <div v-if="value.UncalculatedRoutes.length > 0" class="row justify-content-md-between justify-content-center">
            <div class="col-auto mb-1 mb-md-0">
                <div class="d-flex align-items-center text-nowrap">
                    {{c_total}} rota arasından
                    <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                        <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                    </select>
                    gösteriliyor.
                </div>
            </div>
            <div class="col-auto mb-1 mb-md-0">
                <b-pagination class="mb-0" v-model="currentPage" :total-rows="c_total" :per-page="perPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {BInputGroup,BInputGroupText,BFormInput,BPagination} from 'bootstrap-vue'
import DraftPriceCalculatedBox from '@/views/calculate-price/draft-price/components/DraftPriceCalculatedBox'
import DraftPriceIdleRouteAdd from '@/views/calculate-price/draft-price/components/DraftPriceIdleRouteAdd'
import DraftPriceIdleExactRouteAdd from '@/views/calculate-price/draft-price/components/DraftPriceIdleExactRouteAdd'
import DraftPriceEditRouteDetail from '@/views/calculate-price/draft-price/components/DraftPriceEditRouteDetail'
import GoogleMapsShowRoute from '@/components/GoogleMapsShowRoute'
import GoogleMaps from '@/utilities/google-maps'
import CalculatePriceApi from '@/api/calculate-price'

export default {
    components:{
        DraftPriceCalculatedBox,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        DraftPriceIdleRouteAdd,
        DraftPriceIdleExactRouteAdd,
        DraftPriceEditRouteDetail,
        GoogleMapsShowRoute,
        BPagination
    },
    props:{
        value:Object,
        oneDayKm:Number,
        type:Number
    },
    data() {
        return {
            perPages:[10,20,30,40,50,100],
            perPage:10,
            currentPage:1,
            searchValue:"",
            multipleIdleAdding:false,
            filteredLength:0,
            idleRoute:{
                Province:null,
                District:null,
                Neighbourhood:null,
                LatLng:null,
                BaseRoute:{}
            },
            route:{
                id:null,
                origin:null,
                destination:null,
                waypoints:[],
                avoidHighways:false,
                avoidTolls:false,
                countOfTrips:1,
                countOfDaysWorked:1,
                defaultCountOfDaysWorked:1
            }, 
            idleAdding:false,
        }
    },
    methods:{
        clearForm(){
            this.idleRoute.Province = null
            this.idleRoute.District = null
            this.idleRoute.Neighbourhood = null
            this.idleRoute.LatLng = null
            this.idleRoute.BaseRoute = {}
        },
        selectAll(){
            this.value.UncalculatedRoutes.filter(route=>route.type != 'Exact').forEach(route => {
                this.$set(route,"selected",true)
            })
        },
        unselectAll(){
            this.value.UncalculatedRoutes.filter(route=>route.type != 'Exact').forEach(route => {
                this.$set(route,"selected",false)
            })
        },
        showRoute(item){
            this.route.origin = [item.startProvince?.Name,item.startDistrict?.Name].join(',')
            this.route.avoidHighways = item.isAvoidHighways
            this.route.avoidTolls = item.isAvoidTolls
            if(!!(item?.hasIdle)){
                this.route.destination = [item.idleProvince?.Name,item.idleDistrict?.Name].join(',')
                this.route.waypoints = [[item.endProvince?.Name,item.endDistrict?.Name].join(',')]
            }else{
                this.route.destination = [item.endProvince?.Name,item.endDistrict?.Name].join(',')
                this.route.waypoints = []
            }
            this.$showModal("show-route")
        },
        editIdle(item){
            this.clearForm()
            this.multipleIdleAdding = false
            this.idleRoute.BaseRoute = item
            if(item.type == "Exact"){
                this.$showModal("add-idle-exact")
            }else this.$showModal("add-idle")
        },
        removeIdle(item){
            let route = [item?.idleProvince?.Name,item?.idleDistrict?.Name].join(', ')
            this.$confirm("Aylak Rota Sil",`Bu işlem ${route} aylak rotasını silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    const route = this.value.UncalculatedRoutes.find(r=> r.id == item.id)
                    this.$set(route, 'hasIdle', false)
                    this.$set(route, 'idleProvince', null)
                    this.$set(route, 'idleDistrict', null)
                    this.$set(route, 'idleDistance', 0)
                    this.$set(route, 'countOfDaysWorked', Math.ceil(route.calculatedDistance / this.oneDayKm))
                }
            })
        },
        deleteRoute(item,index){
            let route = [item?.startProvince?.Name,item?.startDistrict?.Name].join(', ') + ' - ' + [item?.endProvince?.Name,item?.endDistrict?.Name].join(', ')
            this.$confirm('Rotayı Sil',`Bu işlem ${route} rotasını silecektir ve geri alınamaz.`).then(res => {
                if(res){
                    this.$delete(this.value.UncalculatedRoutes,index)
                }
            })
        },
        edit(item){
            this.route.id = item.id
            this.route.countOfTrips = item.countOfTrips
            this.route.countOfDaysWorked = item.countOfDaysWorked
            this.route.defaultCountOfDaysWorked = structuredClone(item.countOfDaysWorked)
            this.$showModal("edit-route")
        },
        updateRoute(){
            this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.route.id),"countOfTrips",this.route.countOfTrips)
            this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.route.id),"countOfDaysWorked",this.route.countOfDaysWorked)
            this.$hideModal("edit-route")
        },
        editMultipleIdle(){
            this.clearForm()
            this.multipleIdleAdding = true
            this.$showModal("add-idle")
        },
        addMultipleIdle(){
            this.value.UncalculatedRoutes.filter(cr=>cr.selected).forEach(async _cr=>{
                this.$set(_cr,'selected',false)
                this.$set(_cr, 'hasIdle', true)
                this.$set(_cr, 'idleProvince', this.idleRoute.Province)
                this.$set(_cr, 'idleDistrict', this.idleRoute.District)
                const google = new GoogleMaps()
                this.idleAdding = true
                const res = await google.GetDistance(
                    [_cr.endProvince.Name,_cr.endDistrict.Name].join(","),
                    [this.idleRoute.Province?.Name || "",this.idleRoute.District?.Name || ""].join(","),
                    _cr.isAvoidHighways,
                    _cr.isAvoidTolls)
                this.idleAdding = false
                if(res.rows[0].elements[0].status != "NOT_FOUND"){
                    let sumDistance = Math.ceil(res.rows[0].elements[0].distance?.value/1000) + _cr.calculatedDistance
                    this.$set(_cr, 'idleDistance', sumDistance)
                    this.$set(_cr, 'countOfDaysWorked', Math.ceil(sumDistance/this.oneDayKm))
                }else{
                    let errorRoute = [_cr.endProvince?.Name,_cr.endDistrict?.Name].join(",") + " - " + [_cr.idleProvince?.Name,_cr.idleDistrict?.Name].join(",")
                    this.$alert([errorRoute,"mesafe bilgisi bulunamadı."].join(' '),"AlertCircleIcon","warning")
                }
            })
            this.idleRoute.Province = null
            this.idleRoute.District = null
            this.$hideModal("add-idle")
        },
        async addIdle(){
            this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'hasIdle', true)
            this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'idleProvince', this.idleRoute.Province)
            this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'idleDistrict', this.idleRoute.District)
            if(this.idleRoute.Neighbourhood){
                this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'idleNeighbourhood', this.idleRoute.Neighbourhood)
            }
            if(this.idleRoute.LatLng){
                this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'idleLatLng', this.idleRoute.LatLng)
            }

            const requestData = {
                StartProvinceId:this.idleRoute.BaseRoute.endProvince.Id,
                StartProvinceName:this.idleRoute.BaseRoute.endProvince.Name,
                StartDistrictId:this.idleRoute.BaseRoute.endDistrict.Id,
                StartDistrictName:this.idleRoute.BaseRoute.endDistrict.Name,
                StartNeighborhoodId:this.idleRoute.BaseRoute.endNeighbourhood?.Id || null,
                StartNeighborhoodName:this.idleRoute.BaseRoute.endNeighbourhood?.Name || null,
                StartLocationLat:this.idleRoute.BaseRoute.endLatLng?.Lat ? String(this.idleRoute.BaseRoute.endLatLng.Lat) : null,
                StartLocationLong:this.idleRoute.BaseRoute.endLatLng?.Lng ? String(this.idleRoute.BaseRoute.endLatLng.Lng) : null,
                EndProvinceId:this.idleRoute.Province?.Id || null,
                EndProvinceName:this.idleRoute.Province?.Name || null, 
                EndDistrictId:this.idleRoute.District?.Id || null,
                EndDistrictName:this.idleRoute.District?.Name || null,
                EndNeighborhoodId:this.idleRoute.Neighbourhood?.Id,
                EndNeighborhoodName:this.idleRoute.Neighbourhood?.Name,
                EndLocationLat:this.idleRoute.LatLng?.lat ? String(this.idleRoute.LatLng.lat) : null,
                EndLocationLong:this.idleRoute.LatLng?.lng ? String(this.idleRoute.LatLng.lng) : null,
                Tolls:this.idleRoute.BaseRoute.isAvoidTolls,
                Highways: this.idleRoute.BaseRoute.isAvoidHighways
            }

            CalculatePriceApi.DraftPrice.CalculateDistance(requestData).then(res=>{
                if(res.data.Success){
                    let sumDistance = res.data.Data.Distance + this.idleRoute.BaseRoute.calculatedDistance
                    this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'idleDistance', sumDistance)
                    this.$set(this.value.UncalculatedRoutes.find(r=> r.id == this.idleRoute.BaseRoute.id), 'countOfDaysWorked', Math.ceil(sumDistance/this.oneDayKm))

                    this.idleRoute.BaseRoute = {}
                    this.idleRoute.Province = null
                    this.idleRoute.District = null
                    this.$hideModal("add-idle")
                    this.$hideModal("add-idle-exact")

                }else this.$result(res)
                this.idleAdding = false
            }).catch(err=> {
                this.idleAdding = false
                this.$result(null,err)
            })

        },
        deleteAll(){
            this.$confirm('Tüm Rotaları Sil',`Bu işlem hesaplanmış ${this.value.UncalculatedRoutes.length} adet rotayı silecektir ve geri alınamaz.`).then(res => {
                if(res){
                    this.value.UncalculatedRoutes.splice(0,this.value.UncalculatedRoutes.length)
                }
            })
        }
    },
    computed:{
        c_filteredCalculatedRoutes(){
            let items = this.value.UncalculatedRoutes.filter(cr=>{
                return  cr.referenceModel.VehicleReferenceModelManuelName?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) ||
                        cr.startProvince.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) ||
                        cr.startDistrict.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) || 
                        cr.endProvince.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) ||
                        cr.endDistrict.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) ||
                        cr.idleProvince?.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) ||
                        cr.idleDistrict?.Name?.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase())
            })
            this.filteredLength = items.length
            return items.slice((this.currentPage-1)*this.perPage,this.currentPage*this.perPage)
        },
        c_total(){
            if(this.searchValue){
                return this.filteredLength
            }else return this.value.UncalculatedRoutes.length
        },
        c_selectedCalculatedRoutes(){
            return this.value.UncalculatedRoutes.filter(r=> r.selected).length
        },
    }
}
</script>

<style>
    .per-page-select{
        width: 70px;
    }
</style>